/* Beasock upsell & cross-sell.
   - Product page: "Frequently bought together" (snippets/bsk-fbt.liquid) adds the chosen
     variant plus the ticked add-ons in one request.
   - Cart drawer: free-shipping progress and add-on suggestions are fetched from the
     bsk-cart-upsell section and re-inserted every time Dawn re-renders the drawer.
   - Cart page: the same block is a section in templates/cart.json and refreshes on cart updates. */
(function () {
  if (window.BSKUP) return;
  window.BSKUP = true;

  var SECTION = 'bsk-cart-upsell';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var onCartPage = /\/cart\/?$/.test(location.pathname);

  function fmt(cents, format) {
    var f = format || '${{amount}}';
    var n = (cents || 0) / 100;
    var amount = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function hasPubSub() {
    return typeof publish === 'function' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';
  }

  function addToCart(items) {
    var drawer = onCartPage ? null : document.querySelector('cart-drawer');
    var body = { items: items };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
        if (onCartPage) {
          // the cart page subtotal is not refreshed by Dawn's cart events, so reload it
          location.reload();
        } else if (drawer && res.json.sections) {
          if (hasPubSub()) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bsk-upsell', cartData: res.json });
          if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
          drawer.renderContents(res.json);
        } else {
          location.href = root + 'cart';
        }
        return res.json;
      });
  }

  function busyButton(btn, on, label) {
    if (on) {
      btn.dataset.label = btn.dataset.label || btn.textContent;
      btn.disabled = true;
      btn.textContent = label || 'Adding…';
    } else {
      btn.disabled = false;
      btn.textContent = label || btn.dataset.label;
    }
  }

  /* ---------- Frequently bought together ---------- */
  function mainInput(name) {
    var form = document.querySelector('form[id^="product-form-"]:not([id*="installment"])');
    if (name === 'id') return form && form.querySelector('input[name="id"]');
    return form && document.querySelector('input[name="quantity"][form="' + form.id + '"]');
  }

  function fbtUpdate(box) {
    var prices = {};
    try { prices = JSON.parse(box.querySelector('[data-bsk-prices]').textContent); } catch (e) {}
    var idEl = mainInput('id'), qtyEl = mainInput('quantity');
    var mainPrice = idEl && prices[idEl.value] != null ? prices[idEl.value] : null;
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var money = box.dataset.money;
    var total = mainPrice != null ? mainPrice * qty : 0;
    var count = 1;
    // "Buy 2+ items, save 10%" counts only eligible items (not tagged no-bundle-discount).
    // Shopify rounds the 10% down to the cent on each line, so do the same here.
    var mainElig = box.dataset.mainElig === '1';
    var eligCut = mainElig ? Math.floor(total / 10) : 0, eligQty = mainElig ? qty : 0;
    box.querySelectorAll('[data-bsk-pair]').forEach(function (li) {
      var on = li.querySelector('.bsk-fbt__cb').checked;
      li.classList.toggle('is-off', !on);
      if (!on) return;
      var v = li.querySelector('.bsk-fbt__v');
      var opt = v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
      var price = parseInt(opt && opt.getAttribute('data-price'), 10) || 0;
      total += price;
      count++;
      if (li.dataset.elig === '1') { eligCut += Math.floor(price / 10); eligQty++; }
    });
    var save = eligQty >= 2 ? eligCut : 0;
    var mp = box.querySelector('[data-bsk-main-price]');
    if (mp && mainPrice != null) mp.textContent = fmt(mainPrice, money) + (qty > 1 ? ' × ' + qty : '');
    var was = box.querySelector('[data-bsk-was]'), saveEl = box.querySelector('[data-bsk-save]');
    if (was) { was.hidden = !save; was.textContent = save ? fmt(total, money) : ''; }
    if (saveEl) { saveEl.hidden = !save; saveEl.textContent = save ? 'You save ' + fmt(save, money) + ' with 10% off' : ''; }
    box.querySelector('[data-bsk-total]').textContent = fmt(total - save, money);
    var btn = box.querySelector('[data-bsk-fbt-add]');
    if (!btn.disabled) btn.textContent = count > 1 ? 'Add all ' + count + ' to cart' : 'Add to cart';
  }

  function fbtAll() { document.querySelectorAll('[data-bsk-fbt]').forEach(fbtUpdate); }

  function fbtAdd(btn) {
    var box = btn.closest('[data-bsk-fbt]');
    var msg = box.querySelector('[data-bsk-msg]');
    var idEl = mainInput('id'), qtyEl = mainInput('quantity');
    msg.textContent = '';
    if (!idEl || !idEl.value) { msg.textContent = 'Please choose an available option above first.'; return; }
    var items = [{ id: Number(idEl.value), quantity: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1) }];
    box.querySelectorAll('[data-bsk-pair]').forEach(function (li) {
      if (!li.querySelector('.bsk-fbt__cb').checked) return;
      items.push({ id: Number(li.querySelector('.bsk-fbt__v').value), quantity: 1 });
    });
    busyButton(btn, true);
    addToCart(items)
      .then(function () { busyButton(btn, false); fbtUpdate(box); })
      .catch(function (e) { busyButton(btn, false); fbtUpdate(box); msg.textContent = e.message; });
  }

  /* ---------- Cart drawer / cart page ---------- */
  function fetchBlock() {
    return fetch(root + '?section_id=' + SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  // Keep option changes inside the block away from Dawn's cart-items change handler.
  function shield(el) {
    ['change', 'input'].forEach(function (t) {
      el.addEventListener(t, function (e) { e.stopPropagation(); });
    });
  }

  var gen = 0, busy = false, timer;
  function drawerInner() { return document.querySelector('cart-drawer .drawer__inner'); }

  function fillDrawer() {
    var inner = drawerInner();
    if (!inner || inner.querySelector('[data-bsk-in]') || busy) return;
    busy = true;
    var mine = gen;
    fetchBlock()
      .then(function (doc) {
        if (mine !== gen) return;
        var el = drawerInner();
        if (!el || el.querySelector('[data-bsk-in]')) return;
        var mark = document.createElement('i');
        mark.hidden = true;
        mark.setAttribute('data-bsk-in', '');
        el.appendChild(mark);
        var fs = doc.querySelector('.bsk-fs'), cu = doc.querySelector('.bsk-cu');
        var head = el.querySelector('.drawer__header'), list = el.querySelector('#CartDrawer-CartItems');
        if (fs && head) head.insertAdjacentElement('afterend', fs);
        if (cu && list) { shield(cu); list.appendChild(cu); }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (mine !== gen) schedule();
      });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(fillDrawer, 120); }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      var inner = drawerInner();
      if (inner && !inner.querySelector('[data-bsk-in]')) { gen++; schedule(); }
    }).observe(drawer, { childList: true, subtree: true });
    fillDrawer();
  }

  function fillPage() {
    var host = document.querySelector('main [data-bsk-cu-host]');
    if (!host) return;
    fetchBlock().then(function (doc) {
      var src = doc.querySelector('[data-bsk-cu-src]');
      host.innerHTML = src ? src.innerHTML : '';
    }).catch(function () {});
  }

  function cuAdd(btn) {
    var row = btn.closest('.bsk-cu__it');
    var box = btn.closest('.bsk-cu');
    var msg = box && box.querySelector('[data-bsk-msg]');
    if (msg) msg.textContent = '';
    busyButton(btn, true, '…');
    addToCart([{ id: Number(row.querySelector('.bsk-cu__v').value), quantity: 1 }])
      .then(function () { busyButton(btn, false, 'Added ✓'); })
      .catch(function (e) { busyButton(btn, false); if (msg) msg.textContent = e.message; });
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bsk-fbt-add]');
    if (b) { e.preventDefault(); fbtAdd(b); return; }
    b = e.target.closest('[data-bsk-cu-add]');
    if (b) { e.preventDefault(); cuAdd(b); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.closest('[data-bsk-fbt]') || t.name === 'id' || t.name === 'quantity') setTimeout(fbtAll, 30);
  });
  document.addEventListener('input', function (e) {
    if (e.target.name === 'quantity') setTimeout(fbtAll, 30);
  });

  function init() {
    fbtAll();
    if (!onCartPage) watchDrawer();
    if (onCartPage && hasPubSub()) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'bsk-upsell') return;
        setTimeout(fillPage, 400);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();